import React from "react";

import { FaPlay } from "react-icons/fa";

import { Form } from "react-bootstrap";
// Sample UserInfo component
const UserInfo1 = ({ user }) => {
  return (



    <div className="userinfoform step-content-item step-content-item-active w-100 step-1">
      <div className="step">
        <div class="sec-header-dash mb-1">
          <div class="box-title mb-0" style={{ color: "#ffffff" }}>
            <h3>Your Info</h3>
          </div>
        </div>
        <Form>
          <div className="dashboard-sec mx-0 my-2 p-0">
            <div className="container-fulid">
              <fieldset>
                <div className="form-box-section new-p">
                  <div className="form-box-inner">
                    <div className="form-item">
                      <div className="form-group custom-form-group">
                        <label className="dashboard-form-lable">Name</label>
                        <div className="w-100 me-2">
                          <input
                            type="text"
                            required
                            className="form-control dashboard-input-box-3"
                            disabled={true}
                            value={user.firstname}
                            name={"firstname"}
                          />
                        </div>
                        <div className="w-100">
                          <input
                            type="text"
                            required
                            className="form-control dashboard-input-box-3 me-1"
                            disabled={true}
                            name={"lastname"}
                            value={user.lastname}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-item">
                      <div className="form-group custom-form-group">
                        <Form.Label className="dashboard-form-lable">
                          Email
                        </Form.Label>
                        <div className="w-100">
                          <Form.Control
                            type="email"
                            name="email"
                            disabled={true}
                            required
                            className={`form-control dashboard-input-box-3 `}
                            value={user.email}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-item">
                      <div className="form-group custom-form-group mb-0">
                        <label className="dashboard-form-lable">Phone</label>
                        <div className="w-100">
                          <input
                            type="number"
                            name={"phone"}
                            required
                            disabled={true}
                            className={`form-control dashboard-input-box-3 `}
                            value={user.phone}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div class="sec-header-dash mb-1">
            <div class="box-title mb-0" style={{ color: "#ffffff" }}>
              <h3>Your Height</h3>
            </div>
          </div>
          <div class="dashboard-sec mx-0 my-2 p-0">
            <div className="form-box-section new-p ">
              <div className="form-item height-form-iteam">
                <div className="form-group custom-form-group mb-0">
                  <label className="dashboard-form-lable">Height</label>
                  <div className="d-flex justify-content-end gap-2 align-items-center w-100">
                    {/* <input
                      type="text"
                      name={"height_ft"}
                      required
                      disabled={true}
                      className={`form-select form-control dashboard-input-box-3 select-custom-boxx w-25`}
                      value={user.height_ft + " ft."}
                    /> */}

                    {/* <input
                      type="text"
                      name={"height_in"}
                      required
                      
                      className={`form-select form-control dashboard-input-box-3 select-custom-boxx w-25`}
                      value={user.height_in + " in."}
                    /> */}

                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled={true} value={user.height_ft} aria-label="Default select example">
                      <option value={0}>ft.</option>
                      <option value="4">4 ft.</option>
                      <option value="5">5 ft.</option>
                      <option value="6">6 ft.</option>
                      <option value="7">7 ft.</option>
                    </select>

                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx w-25" disabled={true} value={user.height_in} aria-label="Default select example">
                      <option value={0}>in.</option>
                      <option value="1">0 in.</option>
                      <option value="2">1 in.</option>
                      <option value="3">2 in.</option>
                      <option value="4">3 in.</option>
                      <option value="5">4 in.</option>
                      <option value="6">5 in.</option>
                      <option value="7">6 in.</option>
                      <option value="8">7 in.</option>
                      <option value="9">8 in.</option>
                      <option value="10">9 in.</option>
                      <option value="11">10 in.</option>
                      <option value="12">11 in.</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="sec-header-dash mb-1">
            <div class="box-title mb-0" style={{ color: "#ffffff" }}>
              <h3>Your Dexterity</h3>
            </div>
          </div>
          <div class="dashboard-sec mx-0 my-2 p-0">
            <div className="form-box-section new-p">
              <div className="form-item height-form-iteam">
                <div className="form-group custom-form-group mb-0">
                  <label className="dashboard-form-lable">Dexterity</label>
                  <div className="d-flex justify-content-end gap-2 align-items-center w-100">


                    <input
                      type="text"
                      name={"height_in"}
                      required
                      disabled={true}
                      className={`form-select form-control dashboard-input-box-3 select-custom-boxx w-25`}
                      value={user.dexterity == 1 ? "Right Handed" : "Left Handed"}
                    />


                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>

  );
};

export default UserInfo1;
